import util from '../../../util'

const exportExcelLoadFilesByRegistrationDate = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const filename = payload.filename;
    delete payload.filename;

    const params = new URLSearchParams();
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all')
      params.append('status', payload.status)

      payload.context.axios.post(`/reports/client/${payload.idClient}/filesByRegistrationDateExportExcel`,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename+".xlsx");
      document.body.appendChild(link);
      link.click();


      resolve(response.data)

      console.log(response)
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};


const reportFilesByRegistrationDate = ({ commit } , payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()


    const params = new URLSearchParams();
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    // if (payload.idCategory && payload.idCategory!='all')
    //   params.append('idCategory', payload.idCategory)
    if (payload.pageNumber==null || payload.perPage==null)
    {
      params.append('pageNumber', 1)
      params.append('perPage', 1000)
    }
    else{
      params.append('pageNumber', payload.pageNumber)
      params.append('perPage', payload.context.total)
    }

    payload.context.axios.post('/reports/filesByRegistrationDateAndCategory/client/'+payload.idClient+'/pdf',params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', payload.filename);
      document.body.appendChild(link);
      link.click();



      resolve(response.data)


      console.log(response)
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })


};



const loadFilesByRegistrationDateAndCategory = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const params = new URLSearchParams();
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)

    if (payload.status && payload.status!=='all'){
      params.append('status', payload.status)
    }

    if (payload.pageNumber===null || payload.perPage===null)
    {
      params.append('pageNumber', 1)
       params.append('perPage', 100)
    }
    else{
      params.append('pageNumber', payload.pageNumber)
      params.append('perPage', payload.perPage)
    }

    console.log(payload)

    payload.context.axios.post('/report/'+payload.idClient+'/filesByRegistrationDateAndCategory',params,{headers}).then((response) => {

      commit('setFilesReport',  response.data.files)
      commit('setCountReportFiles',  response.data.count)

      console.log(response)
      resolve(response.data)

    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cargar el reporte.')

      reject(error)
    });

  })

};


const exportFilesByRegistrationDateAndCategory = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()


    const params = new URLSearchParams();
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    // if (payload.idCategory && payload.idCategory!='all')
    //   params.append('idCategory', payload.idCategory)
    if (payload.pageNumber==null || payload.perPage==null)
    {
      params.append('pageNumber', 1)
      params.append('perPage', 1000)
    }
    else{
      params.append('pageNumber', payload.pageNumber)
      params.append('perPage', payload.context.total)
    }

    payload.context.axios.post('/reports/'+payload.idClient+'/filesByRegistrationDateAndCategory'+payload.exten,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', payload.filename);
      document.body.appendChild(link);
      link.click();



      resolve(response.data)


      console.log(response)
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};




//orders

const loadOrdersByOrderDateAndStatus = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()


    const params = new URLSearchParams();
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all')
      params.append('status', payload.status)

    params.append('type', payload.type)

    payload.context.axios.post('/report/'+payload.idClient+'/ordersByOrderDateAndStatus',params,{headers}).then((response) => {
      commit('setOrdersReport',  response.data)


      console.log(response)
      resolve(response.data)

    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cargar el reporte.')

      reject(error)
    });

  })

};



const exportOrdersByOrderDateAndStatus = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()


    const params = new URLSearchParams();
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all')
      params.append('status', payload.status)

    payload.context.axios.post('/reports/'+payload.idClient+'/ordersByOrderDateAndStatus'+payload.exten,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', payload.filename);
      document.body.appendChild(link);
      link.click();


      resolve(response.data)

      console.log(response)
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};

//REPORT ORDERS

const exportPDFOrdersByOrderDateAndStatus = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const filename = payload.filename;
    delete payload.filename;

    const params = new URLSearchParams();
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all'){
      params.append('status', payload.status)
    }
    params.append('type', payload.type)

      payload.context.axios.post(`/report/orders/${payload.idClient}/pdf`,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename+".pdf");
      document.body.appendChild(link);
      link.click();


      resolve(response.data)

      console.log(response)
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};

const exportExcelDetailOrdersByOrderDateAndStatus = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const filename = payload.filename;
    delete payload.filename;

    const params = new URLSearchParams();
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all'){
      params.append('status', payload.status)
    }
    params.append('type', payload.type)


      payload.context.axios.post(`/report/orders/${payload.idClient}/excel-detail`,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename+".xlsx");
      document.body.appendChild(link);
      link.click();


      resolve(response.data)

      console.log(response)
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};

const exportExcelOrdersByOrderDateAndStatus = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const filename = payload.filename;
    delete payload.filename;

    const params = new URLSearchParams()
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all'){
      params.append('status', payload.status)
    }
    params.append('type', payload.type)


      payload.context.axios.post(`/report/orders/${payload.idClient}/excel`,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename+".xlsx");
      document.body.appendChild(link);
      link.click();


      resolve(response.data)

      console.log(response)
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};


//PICKUPS
const loadPickupsByPickupDateAndStatus = ({ commit } , payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const params = new URLSearchParams()
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all'){
      params.append('status', payload.status)
    }
    params.append('type',payload.type)

    console.log('paramsn loadPickupsByPickupDateAndStatus ' , payload)

    payload.context.axios.post('/report/'+payload.idClient+'/pickupsByPickupDateAndStatus',params,{headers}).then((response) => {
      commit('setPickupsReport',  response.data)
      resolve(response.data)

    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cargar el reporte.')

      reject(error)
    });

  })

};

const exportExcelPickupsByPickupDateAndStatus = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const filename = payload.filename;
    delete payload.filename;

    const params = new URLSearchParams()
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all'){
      params.append('status', payload.status)
    }
    params.append('type', payload.type)


      payload.context.axios.post(`/report/pickup/${payload.idClient}/excel`,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename+".xlsx");
      document.body.appendChild(link);
      link.click();


      resolve(response.data)

      console.log(response)
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};

const exportExcelDetailPickupsByPickupDateAndStatus = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const filename = payload.filename;
    delete payload.filename;

    const params = new URLSearchParams()
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all'){
      params.append('status', payload.status)
    }

    params.append('type', payload.type)

      payload.context.axios.post(`/report/pickup/${payload.idClient}/excel-detail`,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename+".xlsx");
      document.body.appendChild(link);
      link.click();


      resolve(response.data)

      console.log(response)
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};

const exportPDFPickupByPickupDateAndStatus = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const filename = payload.filename;
    delete payload.filename;

    const params = new URLSearchParams()
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all'){
      params.append('status', payload.status)
    }
    params.append('type', payload.type)

      payload.context.axios.post(`/report/pickup/${payload.idClient}/pdf`,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename+".pdf");
      document.body.appendChild(link);
      link.click();


      resolve(response.data)

      console.log(response)
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};

//DIGITALIZATION

const exportPDFDigitalizationByDigitalizationDateAndStatus = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const filename = payload.filename;
    delete payload.filename;

    const params = new URLSearchParams()
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all')
      params.append('status', payload.status)

      payload.context.axios.post(`/report/digitalization/${payload.idClient}/pdf`,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename+".pdf");
      document.body.appendChild(link);
      link.click();


      resolve(response.data)

      console.log(response)
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};

const loadDigitalizationByDigitalizationDateAndStatus = ({ commit } , payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const params = new URLSearchParams()
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all')
      params.append('status', payload.status)

    console.log(payload)

    payload.context.axios.post('/report/'+payload.idClient+'/digitalizationsByDigitalizationDateAndStatus',params,{headers}).then((response) => {
      commit('setDigitalizationReport',  response.data)
      resolve(response.data)

    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cargar el reporte.')

      reject(error)
    });

  })

};

const exportExcelDigitalizationByDigitalizationDateAndStatus = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const filename = payload.filename;
    delete payload.filename;

    const params = new URLSearchParams();
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all')
      params.append('status', payload.status)

      payload.context.axios.post(`/report/digitalization/${payload.idClient}/excel`,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename+".xlsx");
      document.body.appendChild(link);
      link.click();


      resolve(response.data)

      console.log(response)
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};

const exportExcelDetailDigitalizationByDigitalizationDateAndStatus = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const filename = payload.filename;
    delete payload.filename;

    const params = new URLSearchParams()
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all')
      params.append('status', payload.status)

      payload.context.axios.post(`/report/digitalization/${payload.idClient}/excel-detail`,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename+".xlsx");
      document.body.appendChild(link);
      link.click();


      resolve(response.data)

      console.log(response)
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};

//FILES BY MONTH
const loadFilesByMonth = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()


    payload.context.axios.get(`/report/filesByMonth/client/${payload.idClient}?${payload.params}`,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al cargar el reporte.')
      reject(error)
    });

  })

};

//BOXES BY MONTH
const loadBoxesByMonth = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`/report/boxesByMonth/client/${payload.idClient}?${payload.params}`,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al cargar el reporte.')
      reject(error)
    });

  })

};


const getExportOrdersMedios = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const filename = payload.filename;
    delete payload.filename;

    const params = new URLSearchParams()
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all'){
      params.append('status', payload.status)
    }
    params.append('type', payload.type)
    params.append('typeExport', payload.typeExport)

      payload.context.axios.post(`/report/orders/${payload.idClient}/exportordersmedios`,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      if(payload.typeExport==='PDF'){
        link.setAttribute('download', filename+".pdf");

      }else {
        link.setAttribute('download', filename+".xlsx");
      }

      document.body.appendChild(link);
      link.click();
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};


const getExportOrdersOtros = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const filename = payload.filename;
    delete payload.filename;

    const params = new URLSearchParams()
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all'){
      params.append('status', payload.status)
    }
    params.append('type', payload.type)
    params.append('typeExport', payload.typeExport)

      payload.context.axios.post(`/report/orders/${payload.idClient}/exportordersotros`,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      if(payload.typeExport==='PDF'){
        link.setAttribute('download', filename+".pdf");

      }else {
        link.setAttribute('download', filename+".xlsx");
      }

      document.body.appendChild(link);
      link.click();
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};

const getExportPickupMedios = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const filename = payload.filename;
    delete payload.filename;

    const params = new URLSearchParams()
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all'){
      params.append('status', payload.status)
    }
    params.append('type', payload.type)
    params.append('typeExport', payload.typeExport)

      payload.context.axios.post(`/report/pickup/${payload.idClient}/exportpickupmedios`,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      if(payload.typeExport==='PDF'){
        link.setAttribute('download', filename+".pdf");

      }else {
        link.setAttribute('download', filename+".xlsx");
      }

      document.body.appendChild(link);
      link.click();
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};


const getExportPickupOtros = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const filename = payload.filename;
    delete payload.filename;

    const params = new URLSearchParams()
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all'){
      params.append('status', payload.status)
    }
    params.append('type', payload.type)
    params.append('typeExport', payload.typeExport)

      payload.context.axios.post(`/report/pickup/${payload.idClient}/exportpickupotros`,params,{headers, responseType: 'blob'}).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      if(payload.typeExport==='PDF'){
        link.setAttribute('download', filename+".pdf");

      }else {
        link.setAttribute('download', filename+".xlsx");
      }

      document.body.appendChild(link);
      link.click();
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};


const reportFilesByRegistrationDateAndStatus = ({ commit } , payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const params = new URLSearchParams()
    params.append('dateFrom', payload.dateFrom)
    params.append('dateTo', payload.dateTo)
    if (payload.status && payload.status!=='all') params.append('status', payload.status)
    params.append('email', 'tcin20@gmail.com')

    payload.context.axios.post('report/filesByRegistrationDateAndStatus/client/'+payload.idClient,params,{headers, responseType: 'blob'}).then((response) => {

      util.showDialogSuccess(payload.context, 'Reporte se está generando. Revise su correo electrónico.')
      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })


};


const loadMediaBoxesSummaryByArea = ({ commit }, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const params = new URLSearchParams();
    if (payload.status && payload.status !== 'all') {
      params.append('status', payload.status)
    }
    if (payload.dateFrom && payload.dateTo) {
      params.append('dateFrom', payload.dateFrom)
      params.append('dateTo', payload.dateTo)
    }

    payload.context.axios.post(`/report/boxes/${payload.idClient}/mediosresumenarea`, params, { headers }).then((response) => {

      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al consultar el resumen.')
      reject(error)
    });

  })

};


const exportMediaBoxesInventory = ({ commit }, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    const filename = payload.filename;

    const params = new URLSearchParams();
    if (payload.status && payload.status !== 'all') {
      params.append('status', payload.status)
    }
    if (payload.dateFrom && payload.dateTo) {
      params.append('dateFrom', payload.dateFrom)
      params.append('dateTo', payload.dateTo)
    }

    payload.context.axios.post(`/report/boxes/${payload.idClient}/mediosinventario`, params, { headers, responseType: 'blob' }).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      resolve(response.data)

    }).catch(error => {

      util.showDialogError(payload.context, 'Ocurrió un error al descargar el reporte.')
      reject(error)
    });

  })

};


export default {
  loadFilesByRegistrationDateAndCategory,
  loadMediaBoxesSummaryByArea,
  exportMediaBoxesInventory,
  exportFilesByRegistrationDateAndCategory,
  loadOrdersByOrderDateAndStatus,
  exportOrdersByOrderDateAndStatus,
  loadFilesByMonth,
  loadBoxesByMonth,

  loadPickupsByPickupDateAndStatus,
  loadDigitalizationByDigitalizationDateAndStatus,
  exportExcelDetailOrdersByOrderDateAndStatus,
  exportExcelOrdersByOrderDateAndStatus,
  exportExcelPickupsByPickupDateAndStatus,
  exportExcelDetailPickupsByPickupDateAndStatus,
  exportExcelDigitalizationByDigitalizationDateAndStatus,
  exportExcelDetailDigitalizationByDigitalizationDateAndStatus,
  exportPDFOrdersByOrderDateAndStatus,
  exportPDFPickupByPickupDateAndStatus,
  exportPDFDigitalizationByDigitalizationDateAndStatus,
  exportExcelLoadFilesByRegistrationDate,
  reportFilesByRegistrationDate,
  getExportOrdersMedios,
  getExportOrdersOtros,
  getExportPickupMedios,
  getExportPickupOtros,
  reportFilesByRegistrationDateAndStatus
};






// WEBPACK FOOTER //
// ./src/store/modules/reports/actions.js